var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"90%","margin-top":"50px"}},[_c('img',{staticStyle:{"width":"100%","border-radius":"20px","border":"1px solid #eeeeee","box-shadow":"0px 0px 10px 0px #aaaaaa"},attrs:{"src":require('../../../assets/imgs/anna_qrcode.jpg')}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-259941fc","hasScoped":false,"transformToRequire":{"video":["app","poster"],"source":"app","img":"app","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/pages/constant/guideQrCode/index.vue
// module id = null
// module chunks = 